import { __decorate } from "tslib";
import { BaseState } from "../state/BaseState";
import { StateDefine } from "../state/utils/StateDefine";
import { getAnyDataSchema, getAnyRealCgiInfo, getAnyStateFeatures, getParamSchema } from "../stateCommon/any";
import { StateProxy } from "./utils/defineProxyState";
export class AnyStateJS extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.stateModel = 'any_JS';
    this.ucTag = '单接口';
    this.features = {};
    this.query = {};
    this.body = {};
    this.data = {};
    this.features = getAnyStateFeatures(this);
    this.initState();
  }
}
AnyStateJS.stateModel = 'any_JS';
__decorate([StateDefine(function () {
  if (!this.features.hostRequestParams) {
    return {
      type: 'any',
      hidden: true
    };
  }
  const {
    cgiName
  } = getAnyRealCgiInfo(this);
  const querySchema = getParamSchema(this, cgiName, 'query');
  if (querySchema) querySchema.title = 'query参数';
  return querySchema || {
    type: 'any',
    hidden: true
  };
}), StateProxy], AnyStateJS.prototype, "query", void 0);
__decorate([StateDefine(function () {
  var _this$collection$coll;
  const emptySchema = {
    type: 'any',
    hidden: true
  };
  const {
    cgiName
  } = getAnyRealCgiInfo(this);
  const isPost = ((_this$collection$coll = this.collection.collectionData) === null || _this$collection$coll === void 0 || (_this$collection$coll = _this$collection$coll.cgiInfo) === null || _this$collection$coll === void 0 || (_this$collection$coll = _this$collection$coll[cgiName]) === null || _this$collection$coll === void 0 ? void 0 : _this$collection$coll.type) === 'post';
  if (!this.features.hostRequestParams || !isPost) {
    return emptySchema;
  }
  const bodySchema = getParamSchema(this, cgiName, 'body');
  if (bodySchema) bodySchema.title = 'body参数';
  return bodySchema || emptySchema;
}), StateProxy], AnyStateJS.prototype, "body", void 0);
__decorate([StateDefine(getAnyDataSchema), StateProxy], AnyStateJS.prototype, "data", void 0);
//# sourceMappingURL=AnyStateJS.js.map
